import React from 'react';
import { Link } from 'react-router-dom';

const TEST_ROUTES = [
  { path: '/mnbvcxz-Test-zxcvbnm', label: 'ML Test' },
  { path: '/test-meta-objects', label: 'Meta Objects Test' },
  { path: '/test-google-ads-object', label: 'Google Ads Object Test' },
  { path: '/test-custom-big-query-object', label: 'Custom BigQuery Test' },
  { path: '/test-google-ads-query-validator', label: 'Google Ads Query Validator' },
  { path: '/testing/intent-classification', label: 'Intent Classification' },
  { path: '/testing/question-testing-meta', label: 'Question Testing Meta' },
  { path: '/testing/component-playground', label: 'Component Playground' },
];

const isOogwUser = () => {
  try {
    const email =
      localStorage.getItem('oogw.ai_shadow_user_email') ||
      localStorage.getItem('oogw.ai_user_email');

    if (!email) return false;

    // Normalize: trim spaces/newlines and lowercase
    const normalizedEmail = email.trim().toLowerCase();

    return normalizedEmail.endsWith('@oogw.ai');
  } catch (e) {
    return false;
  }
};

const TestingIndex: React.FC = () => {
  if (!isOogwUser()) {
    return (
      <div className="p-8">
        <h2 className="text-2xl font-semibold mb-4">Access Denied</h2>
        <p className="text-sm text-muted-foreground">
          This testing area is only available to internal <code>@oogw.ai</code>{' '}
          accounts.
        </p>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h2 className="text-2xl font-semibold mb-4">Testing Routes</h2>
      <ul className="space-y-2">
        {TEST_ROUTES.map((r) => (
          <li key={r.path}>
            <Link className="text-blue-600 hover:underline" to={r.path}>
              {r.label}{' '}
              <span className="text-xs text-muted-foreground">{r.path}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TestingIndex;